import dayjs from "dayjs";
import React from "react";

const SortData = ({ data, key, order }) => {
  if (!key || !order || !data) return data;

  return [...data].sort((a, b) => {
    let valueA = a[key];
    let valueB = b[key];

    // Use `statusText` for sorting instead of Badge
    if (key === "status") {
      valueA = a.statusText;
      valueB = b.statusText;
    }

    if (key === "createdOn") {
      return order === "asc"
        ? dayjs(valueA, "DD MMM YYYY") - dayjs(valueB, "DD MMM YYYY")
        : dayjs(valueB, "DD MMM YYYY") - dayjs(valueA, "DD MMM YYYY");
    }
    if (key === "serial") {
      return order === "asc"
        ? Number(valueA) - Number(valueB)
        : Number(valueB) - Number(valueA);
    }

    return order === "asc"
      ? String(valueA).localeCompare(String(valueB))
      : String(valueB).localeCompare(String(valueA));
  });
};

export default SortData;
